import http from 'plugins/axios';

export default {
  getTicketList(data) {
    return http.get({
      url: '/la/admin/workorder/search',
      data
    });
  },
  getTicketDetail(id) {
    return http.get({
      url: `/la/admin/workorder/detail/${id}`
    });
  },
  updateTicket(data) {
    return http.post({
      url: '/la/admin/workorder/update',
      data
    });
  },
  getTicketDialogue(id) {
    return http.get({
      url: `/la/admin/workorder/searchReply/${id}`
    });
  },
  createTicketDialogueReply(data) {
    return http.post({
      url: '/la/admin/workorder/addReply',
      data
    });
  }
};
